/*
 * @Author: your name
 * @Date: 2020-09-22 12:13:57
 * @LastEditTime: 2021-05-29 12:38:09
 * @LastEditors: lizhihang
 * @Description: In User Settings Edit
 * @FilePath: \x-project-app\src\mixin\form-rule-executor.mixin.js
 */
import { RuleEngine, Assert, SimpleRuleEngine } from '@x-apaas/x-lib-rule-engine'

export default {
  data: function() {
    return {
      debounceExecuteRuleEngine: null,
      executeRuleFunction: null,
      // 规则触发的参数（用于获取表格单元格数据，暂时用不到）
      ruleTriggerParams: {},
      formRuleConfig: {},
      // ruleTriggerDeps（构造好规则，暂时用不到）
      ruleTriggerDeps: {}
    }
  },
  created() {
    this.initDebounceExecuteRuleEngine()
    this.registerFormContextMethod()
  },
  methods: {
    initDebounceExecuteRuleEngine() {
      this.executeRuleFunction = (formRule, excludeTypes) => {
        const calcCount = 3
        for (let i = 0; i < calcCount; i++) {
          for (const uuid in formRule) {
            if (formRule.hasOwnProperty(uuid)) {
              try {
                const compConfig = this.computFormFields.find((item) => {
                  return item.uuid === uuid
                })
                if (!compConfig) {
                  continue
                }
                const compRule = formRule[uuid]
                for (const type in compRule) {
                  if (compRule.hasOwnProperty(type)) {
                    if (type === 'hidden' && !compConfig.enableHiddenRule) {
                      continue
                    } else if (type === 'readOnly' && !compConfig.enableReadOnlyRule) {
                      continue
                    } else if (type === 'required' && !compConfig.enableRequiredRule) {
                      continue
                    } else if (type === 'calc' && excludeTypes && excludeTypes.includes('calc')) {
                      continue
                    } else if (
                      type === 'text' &&
                      ((excludeTypes && excludeTypes.includes('text')) ||
                        compConfig.enableRule !== true)
                    ) {
                      continue
                    } else if (
                      type === 'textarea' &&
                      ((excludeTypes && excludeTypes.includes('textarea')) ||
                        compConfig.enableRule !== true)
                    ) {
                      continue
                    } else if (
                      type === 'money' &&
                      ((excludeTypes && excludeTypes.includes('money')) ||
                        compConfig.enableRule !== true)
                    ) {
                      continue
                    } else if (
                      type === 'number' &&
                      ((excludeTypes && excludeTypes.includes('number')) ||
                        compConfig.enableRule !== true)
                    ) {
                      continue
                    } else if (
                      type === 'date' &&
                      ((excludeTypes && excludeTypes.includes('date')) ||
                        compConfig.enableRule !== true)
                    ) {
                      continue
                    }
                    const ruleConfig = compRule[type]
                    let result
                    if (ruleConfig.ruleType === 'advanced') {
                      const rule = {
                        ruleId: ruleConfig.advancedRuleId,
                        ruleStack: ruleConfig.advancedRuleConfig.advancedRuleList
                      }
                      try {
                        result = RuleEngine.getInstance().executeRule(rule)
                        if (
                          (typeof result === 'number' && isNaN(result)) ||
                          result === Infinity ||
                          result === -Infinity
                        ) {
                          result = null
                        }
                        // 抽屉中最开始不应该显示计算的数据
                        if (
                          type === 'calc' ||
                          type === 'text' ||
                          type === 'textarea' ||
                          type === 'money' ||
                          type === 'number' ||
                          type === 'date'
                        ) {
                          this.setComponentValue(this.formData, compConfig, result)
                        }
                      } catch (error) {
                        if (
                          type === 'calc' ||
                          type === 'text' ||
                          type === 'textarea' ||
                          type === 'money' ||
                          type === 'number' ||
                          type === 'date'
                        ) {
                          this.setComponentValue(this.formData, compConfig, result)
                        }
                        console.error(error)
                      }
                    } else {
                      try {
                        result = SimpleRuleEngine.getInstance().executeRule(ruleConfig.simpleRuleConfig)
                        console.log(result)
                      } catch (error) {
                        console.error(error)
                      }
                    }

                    // 更新组件配置中的隐藏和显示
                    if (type === 'hidden' || type === 'readOnly' || type === 'required') {
                      let ruleConfig = this.formRuleConfig[uuid] || {}
                      ruleConfig[type] = !!result
                      // if (this.ruleTriggerParams.propKey) {
                      this.$set(this.formRuleConfig, uuid, ruleConfig)
                      // 只读和隐藏规则同时配置，只读规则不生效
                      this.formRuleConfig = this.$lodash.cloneDeep(this.formRuleConfig)
                      // }
                    }
                  }
                }
              } catch (err) {
                console.error(err)
              }
            }
          }
          // this.ruleTriggerParams = {}
        }
        // this.formRuleConfig = JSON.parse(JSON.stringify(this.formRuleConfig))
      }
      this.debounceExecuteRuleEngine = this.$lodash.debounce(this.executeRuleFunction, 300)
    },
    /**
     * 设置表单的值
     */
    setComponentValue(formData, compConfig, value) {
      // 格式化value
      let formatValue = null
      if (compConfig && compConfig.methods && compConfig.methods.lcFormatValue) {
        if (compConfig.tableUuid && Array.isArray(value)) {
          // 如果是表格里面的数据
          formatValue = value.map((item) => {
            return compConfig.methods.lcFormatValue(item, compConfig)
          })
        } else {
          formatValue = compConfig.methods.lcFormatValue(value, compConfig)
        }
      } else {
        formatValue = value
      }
      if (compConfig.tableUuid) {
        const tableData = formData[compConfig.tableUuid]
        if (tableData) {
          tableData.forEach((row, index) => {
            if (Array.isArray(formatValue)) {
              row[compConfig.uuid] = formatValue[index]
            } else {
              row[compConfig.uuid] = formatValue
            }
          })
          this.$set(formData, compConfig.tableUuid, tableData)
        }
        // }
      } else {
        // 判断是否在列中
        this.$set(formData, compConfig.uuid, formatValue)
      }
    },
    // 初始化组件trigger
    initRuleTriggerDeps() {
      const formRule = this.editConfig.xdapFormConfig.detailPage.formRule
      const ruleTriggerDeps = {}
      this.ruleTriggerDeps = ruleTriggerDeps
      Object.keys(formRule).forEach((itemUuid) => {
        const itemRule = formRule[itemUuid]
        Object.keys(itemRule).forEach((type) => {
          const itemTypeRule = itemRule[type]
          if (itemTypeRule.ruleType === 'simple') {
            // 解析简单规则依赖
            const simpleRuleConfig = itemTypeRule.simpleRuleConfig
            if (simpleRuleConfig) {
              const formFieldRuleList = simpleRuleConfig.formFieldRuleList
              formFieldRuleList.forEach((formFieldRule) => {
                formFieldRule.fieldRuleList.forEach((fieldRule) => {
                  if (ruleTriggerDeps[itemUuid]) {
                    ruleTriggerDeps[itemUuid].add(fieldRule.uuid)
                  } else {
                    ruleTriggerDeps[itemUuid] = new Set()
                    ruleTriggerDeps[itemUuid].add(fieldRule.uuid)
                  }
                })
              })
            }
          } else if (itemTypeRule.ruleType === 'advanced') {
            // 解析高级规则依赖
            const advancedRuleConfig = itemTypeRule.advancedRuleConfig
            if (advancedRuleConfig) {
              advancedRuleConfig.advancedRuleList &&
                advancedRuleConfig.advancedRuleList.forEach((advancedRule) => {
                  // if (advancedRule.ruleType === 'COMPONENT_VALUE') {
                  if (ruleTriggerDeps[itemUuid]) {
                    ruleTriggerDeps[itemUuid].add(advancedRule.value)
                  } else {
                    ruleTriggerDeps[itemUuid] = new Set()
                    ruleTriggerDeps[itemUuid].add(advancedRule.value)
                  }
                  // }
                })
            }
          }
        })
      })
    },
    /**
     * 手动触发规则
     */
    triggerRule() {
      if (this.formType === 'DETAIL_FORM') {
        this.executeRuleFunction(this.editConfig.xdapFormConfig.detailPage.formRule, [
          'calc',
          'number',
          'money',
          'text',
          'textarea',
          'date'
        ])
      } else {
        this.executeRuleFunction(this.editConfig.xdapFormConfig.detailPage.formRule)
      }
    },
    registerFormContextMethod() {
      const getComponentValueFunction = {
        name: 'getComponentValue',
        mockFunction: (...args) => {},
        executeFunction: (...args) => {
          args = args || arguments
          if (args[0]) {
            const arr = args[0].split('.')
            if (arr.length > 1) {
              if (this.formData[arr[0]]) {
                // const tableInfo = this.ruleTriggerParams.tableInfo
                // if (tableInfo) {
                //   return this.formData[arr[0]][tableInfo.rowIndex][arr[1]]
                // } else {
                const tableValues = this.formData[arr[0]].map((item) => item[arr[1]])
                return [...tableValues]
                // }
              } else {
                return []
              }
            } else {
              const compConfig = this.computFormFields.find((item) => {
                return item.uuid === arr[0]
              })
              if (compConfig) {
                if (compConfig.componentType === 'FORM_MONEY_INPUT') {
                  return this.formData[arr[0]]
                    ? Number(this.formData[arr[0]])
                    : this.formData[arr[0]]
                } else if (compConfig.componentType === 'FORM_DEPARTMENT_SELECT') {
                  return (
                    this.formData[arr[0]] && this.formData[arr[0]].map((item) => item.id).join(',')
                  )
                } else if (compConfig.componentType === 'FORM_PEOPLE_SELECT') {
                  return (
                    this.formData[arr[0]] && this.formData[arr[0]].map((item) => item.id).join(',')
                  )
                } else if (compConfig.componentType === 'FORM_DATA_SELECTOR') {
                  return this.formData[arr[0]] && this.formData[arr[0]] && this.formData[arr[0]].id
                } else {
                  return this.formData[arr[0]]
                }
                // else if (compConfig.componentType === 'FORM_SELECT_INPUT') {
                //   return (this.formData[arr[0]] || []).map(id => {
                //     let option = compConfig.chooseOptions.find(item => item.id === id)
                //     return option ? option.label : ''
                //   }).toString()
                // }
              }
            }
          }
          return undefined
        }
      }

      const getComponentFunction = {
        name: 'getComponent',
        mockFunction: (...args) => {},
        executeFunction: (...args) => {
          args = args || arguments
          if (args[0]) {
            const arr = args[0].split('.')
            let compConfig
            if (arr.length > 1) {
              compConfig = this.computFormFields.find((item) => {
                return item.uuid === arr[1]
              })
              if (this.formData[arr[0]]) {
                // const tableInfo = this.ruleTriggerParams.tableInfo
                // if (tableInfo) {
                //   return {
                //     ...compConfig,
                //     componentValue: this.formData[arr[0]][tableInfo.rowIndex]
                //       ? this.formData[arr[0]][tableInfo.rowIndex][arr[1]]
                //       : undefined
                //   }
                // } else {
                const tableValues = this.formData[arr[0]].map((item) => item[arr[1]])
                return {
                  ...compConfig,
                  componentValue: [...tableValues]
                }
                // }
              } else {
                return {
                  ...compConfig,
                  componentValue: []
                }
              }
            } else {
              compConfig = this.computFormFields.find((item) => {
                return item.uuid === arr[0]
              })
              if (compConfig) {
                return {
                  ...compConfig,
                  componentValue: this.formData[arr[0]]
                }
              }
            }
          }
          return undefined
        }
      }
      // 高级版
      RuleEngine.getInstance().registerContextMethod(
        getComponentValueFunction.name,
        getComponentValueFunction
      )
      RuleEngine.getInstance().registerContextMethod(
        getComponentFunction.name,
        getComponentFunction
      )

      const setValueFunction = {
        name: 'xdapsetvalue',
        needComponentConfig: true,
        needYield: true,
        mockFunction: (...args) => {
          Assert.argsLength(args, 2)
        },
        executeFunction: (...args) => {
          Assert.argsLength(args, 2)
          args = args.map((arg) => {
            return typeof arg === 'object' && typeof arg.next === 'function'
              ? arg.next().value
              : arg
          })
          args[1] =
            args[1] && typeof args[1] === 'object' && args[1].componentType
              ? args[1].componentValue
              : args[1]
          this.$set(this.formData, args[0].uuid, args[1])
        }
      }
      RuleEngine.getInstance().registerContextMethod(setValueFunction.name, setValueFunction)

      // 简易版
      SimpleRuleEngine.getInstance().registerContextMethod(
        getComponentValueFunction.name,
        getComponentValueFunction
      )
      SimpleRuleEngine.getInstance().registerContextMethod(getComponentFunction.name, getComponentFunction)
      const dayjsFunction = {
        name: 'dayjs',
        mockFunction: (...args) => {},
        executeFunction: (...args) => {
          return this.$dayjs(args[0])
        }
      }
      SimpleRuleEngine.getInstance().registerContextMethod(dayjsFunction.name, dayjsFunction)

      const getCurrentDeptFunction = {
        name: 'getCurrentDept',
        mockFunction: (...args) => {},
        executeFunction: (...args) => {
          return this.department && this.department.id
        }
      }
      SimpleRuleEngine.getInstance().registerContextMethod(getCurrentDeptFunction.name, getCurrentDeptFunction)

      const getCurrentUserFunction = {
        name: 'getCurrentUser',
        mockFunction: (...args) => {},
        executeFunction: (...args) => {
          return this.userInfo && this.userInfo.id
        }
      }
      SimpleRuleEngine.getInstance().registerContextMethod(getCurrentUserFunction.name, getCurrentUserFunction)
    },

    /**
     * 组件触发规则
     * @param {*} $event
     */
    formEventEmit($event) {
      // TOTO 感觉 ruleTriggerParams 用不到
      // this.ruleTriggerParams = { ...$event }
      this.debounceExecuteRuleEngine(this.editConfig.xdapFormConfig.detailPage &&
        this.editConfig.xdapFormConfig.detailPage.formRule)
    }
  }
}
